import { axiosJSONInstance } from '@/config';
import {
  PickupAddressResponse,
  PickupFetchAddressResponse,
  SinglePickupResponse,
  PickupRequest,
  SinglePickupAddressResponse,
} from '@/types'; // Ensure this path is correct based on your folder structure
import { createPaginationSearchParams } from '@/utils';

// Fetch all pickup addresses
export const fetchPickupAddresses = async (page?: number): Promise<PickupFetchAddressResponse> => {
  const searchParams = createPaginationSearchParams(page ?? 1, 200);

  const response = await axiosJSONInstance.get(
    `/merchants/saved-pick-up-addresses?${searchParams}`,
  );
  return response.data;
};

// Fetch a pickup address by UID
export const fetchPickupAddressByUID = async (
  uid: string,
): Promise<SinglePickupAddressResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/saved-pick-up-addresses/${uid}`);
  return response.data;
};

// Fetch Last Cod Pickup Address
export const fetchPickupLastCod = async (): Promise<SinglePickupResponse> => {
  const response = await axiosJSONInstance.get(
    `/merchants/saved-pick-up-addresses/default-cod-drop-off`,
  );
  return response.data;
};

// Create new pickup address
export const createPickupAddress = async (data: PickupRequest): Promise<SinglePickupResponse> => {
  const response = await axiosJSONInstance.post('/merchants/saved-pick-up-addresses', data);
  return response.data;
};

// Update pickup address
export const updatePickupAddress = async (
  data: PickupRequest,
  uid: string,
): Promise<SinglePickupResponse> => {
  const response = await axiosJSONInstance.patch(`/merchants/saved-pick-up-addresses/${uid}`, data);
  return response.data;
};

// Delete pickup address by UID
export const deletePickupAddress = async (uid: string): Promise<void> => {
  await axiosJSONInstance.delete(`/merchants/saved-pick-up-addresses/${uid}`);
};
